import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { SEO_LIMITS, validateSeoAnchors } from '../../lib/catalogSeo';

const SeoCounter = ({ value, limit }) => (
  <span className={`text-xs ${(value || '').length > limit ? 'text-destructive' : 'text-muted-foreground'}`}>
    {(value || '').length}/{limit}
  </span>
);

export default function AdminSeoFields({ form, setForm, idPrefix = 'seo', onFillTemplate }) {
  const anchorCheck = validateSeoAnchors({
    title: form.meta_title || '',
    description: form.meta_description || '',
    keywords: form.meta_keywords || '',
  });

  return (
    <div className="space-y-4 rounded-lg border border-border/60 p-4">
      <p className="text-sm font-semibold">SEO (title / description / keywords)</p>
      {onFillTemplate && (
        <Button type="button" variant="outline" size="sm" onClick={onFillTemplate}>
          Заполнить по шаблону
        </Button>
      )}
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor={`${idPrefix}-meta-title`}>Meta title</Label>
          <SeoCounter value={form.meta_title || ''} limit={SEO_LIMITS.metaTitle} />
        </div>
        <Input
          id={`${idPrefix}-meta-title`}
          value={form.meta_title || ''}
          onChange={(e) => setForm((prev) => ({ ...prev, meta_title: e.target.value }))}
          placeholder="Лицензии … | Антология"
        />
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor={`${idPrefix}-meta-description`}>Meta description</Label>
          <SeoCounter value={form.meta_description || ''} limit={SEO_LIMITS.metaDescription} />
        </div>
        <Textarea
          id={`${idPrefix}-meta-description`}
          value={form.meta_description || ''}
          onChange={(e) => setForm((prev) => ({ ...prev, meta_description: e.target.value }))}
          rows={3}
          placeholder="Оплата в рублях по безналичному расчёту…"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-meta-keywords`}>Meta keywords</Label>
        <Textarea
          id={`${idPrefix}-meta-keywords`}
          value={form.meta_keywords || ''}
          onChange={(e) => setForm((prev) => ({ ...prev, meta_keywords: e.target.value }))}
          rows={2}
        />
      </div>
      {form.seo_primary_query !== undefined && (
        <div className="space-y-2">
          <Label htmlFor={`${idPrefix}-primary-query`}>Главный запрос (title)</Label>
          <Input
            id={`${idPrefix}-primary-query`}
            value={form.seo_primary_query || ''}
            onChange={(e) => setForm((prev) => ({ ...prev, seo_primary_query: e.target.value }))}
          />
        </div>
      )}
      {!anchorCheck.valid && (form.meta_title || form.meta_description) && (
        <p className="text-xs text-amber-600">
          SEO-якоря: проверьте «лицензия», «цена» и фразу «Оплата в рублях по безналичному расчёту» в description.
        </p>
      )}
    </div>
  );
}
